import {Component, Input} from '@angular/core';
import {FilterModelDto} from "../../../../models/filter.model";

@Component({
  selector: 'app-payment-view-page-filter',
  templateUrl: './payment-view-page-filter.component.html',
  styleUrls: ['./payment-view-page-filter.component.scss']
})
export class PaymentViewPageFilterComponent {
  @Input() filterStatuses: FilterModelDto[] | undefined
  @Input() filterBanks: FilterModelDto[] | undefined
}
